import PropTypes from "prop-types";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Button, Col, Image, Row } from "react-bootstrap";
import { AngleLeftIcon, AngleRightIcon } from "../data/iconImage";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/th";

moment.locale("th");
const localizer = momentLocalizer(moment);

const CustomToolbar = ({ date, views, onView, onNavigate }) => {
  const buttonText = { month: "เดือน", week: "สัปดาห์", day: "วัน" };

  return (
    <Row className="mb-3 justify-content-between">
      <Row as={Col} className="align-items-center">
        <Button
          as={Col}
          variant="outline-success"
          className="w-auto col-1 border-0"
          onClick={() => onNavigate("PREV")}
        >
          <Image src={AngleLeftIcon} alt="Prev Icon" />
        </Button>

        <Col sm={2} className="w-auto fs-4 text-center">
          {moment(date).format("MMMM YYYY")}
        </Col>

        <Button
          as={Col}
          variant="outline-success"
          className="w-auto col-1 border-0"
          onClick={() => onNavigate("NEXT")}
        >
          <Image src={AngleRightIcon} alt="Next Icon" />
        </Button>
      </Row>

      <Row as={Col} className="justify-content-end align-items-center">
        {views.map((view, idx) => (
          <Button
            as={Col}
            key={idx}
            variant="success"
            className="w-auto col-1 mx-1 px-4 d-flex align-items-center rounded-pill"
            onClick={() => onView(view)}
          >
            <span className="py-1">{buttonText?.[view]}</span>
          </Button>
        ))}
      </Row>
    </Row>
  );
};

const CalendarComponent = ({ events, onRangeChange }) => {
  const customFormats = {
    dateFormat: (date, culture, localizer) =>
      localizer.format(date, "D", culture),
    weekdayFormat: (date, culture, localizer) =>
      localizer.format(date, "dd", culture),
    dayFormat: (date, culture, localizer) =>
      localizer.format(date, "Do dd", culture),
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "HH:mm", culture)
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    const backgroundColor = `rgba(${parseInt(
      event.hexColor.slice(1, 3),
      16
    )}, ${parseInt(event.hexColor.slice(3, 5), 16)}, ${parseInt(
      event.hexColor.slice(5, 7),
      16
    )}, 0.15)`;
    const style = {
      backgroundColor: backgroundColor,
      borderRadius: "4px",
      //opacity: 0.5,
      color: event.hexColor,
      border: "0px",
      display: "block",
      padding: "0px",
      fontSize: "1.125rem"
    };
    return { style };
  };

  return (
    <Calendar
      onRangeChange={onRangeChange}
      events={events}
      defaultView="month"
      className="mx-auto"
      localizer={localizer}
      formats={customFormats}
      views={["month", "week", "day"]}
      eventPropGetter={eventStyleGetter}
      style={{ width: "65vw", maxWidth: "100%", height: "85vh" }}
      dayPropGetter={(date) => {
        if (date.getDay() === 0) return { style: { color: "#921b1d" } };
        if (date.getDay() === 6) return { style: { color: "#0068ad" } };
      }}
      components={{
        toolbar: CustomToolbar,
        day: {
          header: ({ date, label, localizer }) =>
            localizer.format(date, "Do dddd", label)
        }
      }}
    />
  );
};

CustomToolbar.propTypes = {
  date: PropTypes.object,
  views: PropTypes.array,
  onView: PropTypes.func,
  onNavigate: PropTypes.func
};

CalendarComponent.propTypes = {
  events: PropTypes.array,
  onRangeChange: PropTypes.func
};

export default CalendarComponent;
